<div class="mb-4 flex flex-col gap-2 rounded-lg border border-gray-200 bg-white p-6 filters-shadow">
  <div class="grid grid-cols-3 gap-6 py-2">
    <app-filter-item-search
      [label]="isArabic() ? 'اسم الصنف' : 'Product Name'"
      [placeholder]="isArabic() ? 'ابحث باسم الصنف...' : 'Search by product name...'"
      [(searchTerm)]="quickSearch" />

    <app-filter-select-component
      [label]="isArabic() ? 'الفئات' : 'Category'"
      [defaultOption]="isArabic() ? 'اختر فئة' : 'Select category...'"
      [options]="categories()"
      [value]="selectedCategoryId()"
      (valueChange)="onCategorySelect($event)" />

    <app-filter-select-component
      [label]="isArabic() ? 'الفئات الفرعية' : 'Sub Category'"
      [defaultOption]="isArabic() ? 'اختر فئة فرعية' : 'Select sub-category...'"
      [options]="subCategories()?.list ?? []"
      [(value)]="selectedSubCategoryId" />

    <app-filter-select-component
      [label]="isArabic() ? 'الشركة المصنعة' : 'Manufacturing Company'"
      [defaultOption]="isArabic() ? 'اختر الشركة المصنعة' : 'Select company...'"
      [options]="mfgCompanies()"
      [(value)]="selectedMfgCompanyId" />

    <app-filter-select-component
      [label]="isArabic() ? 'التوفر' : 'Availability'"
      [defaultOption]="isArabic() ? 'جميع الأصناف' : 'All Products'"
      [options]="availabilityOptions()"
      [(value)]="selectedAvailability" />

    <div></div>

    <app-filter-price-range-input
      [label]="isArabic() ? 'سعر الصيدلي' : 'Pharmacy Price'"
      [minPlaceholder]="isArabic() ? 'الحد الأدنى' : 'Min Price'"
      [maxPlaceholder]="isArabic() ? 'الحد الأقصى' : 'Max Price'"
      [(minVal)]="businessPriceFrom"
      [(maxVal)]="businessPriceTo" />

    <app-filter-price-range-input
      [label]="isArabic() ? 'سعر الجمهور' : 'People Price'"
      [minPlaceholder]="isArabic() ? 'الحد الأدنى' : 'Min Price'"
      [maxPlaceholder]="isArabic() ? 'الحد الأقصى' : 'Max Price'"
      [(minVal)]="customerPriceFrom"
      [(maxVal)]="customerPriceTo" />
  </div>

  <div class="section-border flex flex-col items-end justify-between gap-4 border-t pt-4 md:flex-row">
    <div class="flex flex-wrap items-center gap-3">
      <app-filter-sorting-component
        [orderBy]="orderBy()"
        (orderByChange)="orderBy.set($event)"
        [orderDir]="orderDir()"
        [sortOptions]="sortOptions()"
        (toggleOrder)="onToggleSortOrder()"></app-filter-sorting-component>
    </div>

    <div class="flex w-full justify-end gap-3 pb-1 md:w-auto">
      <button
        (click)="onReset()"
        class="borderTabsColor textTabsColor hover-bg-primary-10 cursor-pointer rounded-[6px] border px-8 py-2.5 text-[13px] font-bold transition-colors">
        <ng-container i18n="@@stockfilter.reset">Clear</ng-container>
      </button>
      <button
        (click)="onApply()"
        class="bgTabsColor hover-bg-primary-hover cursor-pointer rounded-[6px] px-10 py-2.5 text-[13px] font-bold text-white shadow-sm transition-all">
        <ng-container i18n="@@stock.apply">Apply</ng-container>
      </button>
    </div>
  </div>
</div>
